import type { QueryClient } from "@tanstack/react-query";

async function invalidateScheduleData(queryClient: QueryClient) {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ["schedule-blocks"] }),
    queryClient.invalidateQueries({ queryKey: ["project-schedule-blocks"] }),
    queryClient.invalidateQueries({ queryKey: ["schedule-week-blocks"] }),
  ]);
}

export async function invalidateTicketData(queryClient: QueryClient) {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ["tickets"] }),
    queryClient.invalidateQueries({ queryKey: ["approvals"] }),
    queryClient.invalidateQueries({ queryKey: ["dashboard"] }),
    queryClient.invalidateQueries({ queryKey: ["company-profile"] }),
    queryClient.invalidateQueries({ queryKey: ["billing-overview"] }),
    queryClient.invalidateQueries({ queryKey: ["reports-overview"] }),
    queryClient.invalidateQueries({ queryKey: ["projects"] }),
    queryClient.invalidateQueries({ queryKey: ["clients"] }),
    invalidateScheduleData(queryClient),
  ]);
}

export async function invalidateProjectData(queryClient: QueryClient) {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ["projects"] }),
    queryClient.invalidateQueries({ queryKey: ["project-labels"] }),
    queryClient.invalidateQueries({ queryKey: ["dashboard"] }),
    queryClient.invalidateQueries({ queryKey: ["billing-overview"] }),
    queryClient.invalidateQueries({ queryKey: ["reports-overview"] }),
    queryClient.invalidateQueries({ queryKey: ["approvals"] }),
    queryClient.invalidateQueries({ queryKey: ["tickets"] }),
    invalidateScheduleData(queryClient),
  ]);
}

export async function invalidateClientData(queryClient: QueryClient) {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ["clients"] }),
    queryClient.invalidateQueries({ queryKey: ["projects"] }),
    queryClient.invalidateQueries({ queryKey: ["tickets"] }),
    queryClient.invalidateQueries({ queryKey: ["dashboard"] }),
    queryClient.invalidateQueries({ queryKey: ["billing-overview"] }),
    queryClient.invalidateQueries({ queryKey: ["reports-overview"] }),
    queryClient.invalidateQueries({ queryKey: ["approvals"] }),
    invalidateScheduleData(queryClient),
  ]);
}

export async function invalidatePriceBookData(queryClient: QueryClient) {
  await queryClient.invalidateQueries({ queryKey: ["price-book"] });
}

export async function invalidateProjectLabelData(queryClient: QueryClient) {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ["project-labels"] }),
    queryClient.invalidateQueries({ queryKey: ["projects"] }),
  ]);
}
